import BaseComponent from 'foundation/base-component';
import baseItemTemplate from '../../form-custom-select/html/item.hbs';
import itemContentTemplate from '../html/item.hbs';
import baseChoiseTemplate from '../../form-custom-select/html/choise.hbs';
import choiseContentTemplate from '../html/choise.hbs';
import ChoicesWrapper from '../../form-custom-select/js/choices-wrapper';

export default class FormPhoneInputComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.countries = this.options.countries || [];
        this.init();
    }

    static getRequiredRefs() {
        return ['country'];
    }

    init() {
        this.choicesWrapperInstance = new ChoicesWrapper(this.refs.country, {
            choices: this.getChoices(),
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            callbackOnCreateTemplates(strToEl) {
                const itemSelectText = this.config.itemSelectText;
                return {
                    item(classNames, data) {
                        return strToEl(baseItemTemplate({
                            classNames,
                            data,
                            content: itemContentTemplate({ classNames, data })
                        }));
                    },
                    choice(classNames, data) {
                        return strToEl(baseChoiseTemplate({
                            classNames,
                            data,
                            itemSelectText,
                            content: choiseContentTemplate({ classNames, data, itemSelectText })
                        }));
                    },
                };
            },
        });
    }

    getChoices() {
        return this.countries.map(({
            value, label, image, selected = false
        }) => ({
            value,
            label,
            selected,
            disabled: false,
            customProperties: { image }
        }));
    }

    onDestroy() {
        this.choicesWrapperInstance.destroy();
    }
}
